export const environment = {
  production: false,
  apiUrl: 'https://gzre-dev.gozmart.ch/api/v1',
  baseUrl: 'https://gzre-dev.gozmart.ch',
  buildingVersion: '1.0RC32 - 210114'
};
